import { Storage } from './storage';

export enum DeletedFilesSearchEnum {
    EXCLUDE_DELETED = 1,
    INCLUDE_DELETED = 2,
    ONLY_DELETED = 3
}
export interface SearchResult {
    type: string;
    file_path: string;
    file_name: string;
    file_content: string;

    file_extension?: string;
    template_id?: number;

    id?: number;
    storage?: Storage;
}

export interface SearchResponse {
    found: number;
    
    results: SearchResult[];
}